const authRoutes = [
    {
        path: "/login",
        meta: {
            bodyId: "login",
            layout: "LoginLayout"
        },
        component: () => import("@/views/auth/SignIn"),
    },
    // local 테스트를 위한 패스 (리다이렉트 URI 이슈)
    {
        path: "/auth",
        meta: {
            bodyId: "login",
            layout: "LoginLayout"
        },
        component: () => import("@/views/auth/SignIn"),
    },
    {
        path: "/sign-up",
        meta: {
            bodyId: "join",
            layout: "LoginLayout"
        },
        component: () => import("@/views/auth/TermsAgreement"),
    },
    // 카카오 로그인 이전 회원가입
    // {
    //     path: "/sign-up",
    //     meta: {
    //         bodyId: "join",
    //         layout: "LoginLayout"
    //     },
    //     component: () => import("@/views/auth/SignUpJoin"),
    // },

    // {
    //     path: "/sign-up",
    //     meta: {
    //         bodyId: "join",
    //         layout: "LoginLayout"
    //     },
    //     component: () => import("@/views/auth/SignUp"),
    // },
    // {
    //     path: "/sign-up-form",
    //     meta: {
    //         bodyId: "join02",
    //         layout: "LoginLayout"
    //     },
    //     component: () => import("@/views/auth/SignUpForm"),
    // },
    // {
    //     path: "/sign-up-finish",
    //     meta: {
    //         bodyId: "join03",
    //         layout: "LoginLayout"
    //     },
    //     component: () => import("@/views/auth/SignUpFinish"),
    // },

    // 계정 복구(탭)
    {
      path: "/recovery",
      name: "AuthRecovery",
      meta: { bodyId: "find", layout: "LoginLayout" },
      component: () => import("@/views/auth/recovery/Recovery.vue"),
      redirect: { name: "AuthRecoveryId" },
      children: [
        {
          path: "id",
          name: "AuthRecoveryId",
          meta: { bodyId: "find", layout: "LoginLayout" },
          // 기존 파일 재사용
          component: () => import("@/views/auth/FindId.vue"),
        },
        {
          path: "password",
          name: "AuthRecoveryPassword",
          meta: { bodyId: "find", layout: "LoginLayout" },
          // 기존 파일 재사용
          component: () => import("@/views/auth/FindPassword.vue"),
        },
      ],
    },

    {
        path: "/find-password",
        meta: {
            bodyId: "find",
            layout: "LoginLayout"
        },
        component: () => import("@/views/auth/FindPassword"),
    },
    {
        path: "/password-reset-comp",
        meta: {
            bodyId: "edit_password",
            layout: "MainLayout",
        },
        component: () => import("@/views/myPage/EditPasswordComplete"),
    },
    {
        path: "/find-id",
        meta: {
            bodyId: "find",
            layout: "LoginLayout"
        },
        component: () => import("@/views/auth/FindId"),
    },
    {
        path: "/phone-auth",
        meta: {
            bodyId: "main_nonCertify",
            layout: "MainLayout"
        },
        component: () => import("@/views/auth/PhoneAuthorize"),
    },

]
export default authRoutes
